import { makeStyles } from "@material-ui/core/styles";
import { PRIMARY_FONT_TEXT, TITLE_FONT } from "../../theme";

export const useStyles = makeStyles({
  container: {
    maxWidth: "900px",
    margin: "0 auto",
    padding: "24px !important",
    fontFamily: PRIMARY_FONT_TEXT,
  },
  titleContainer: {
    display: "flex",
    alignItems: "flex-end",
    fontFamily: TITLE_FONT,
  },
  title: {
    margin: 0,
    fontSize: "48px",
  },
  partOfSpeech: {
    fontStyle: "italic",
    fontWeight: "normal",
    margin: "0 0 8px 24px",
  },
  hr: {
    margin: "26px 0",
  },
  pronunciation: {
    opacity: 0.8,
    marginBottom: 16,
  },
  pronunciationText: {
    marginRight: 12,
    fontSize: "24px",
  },
  definition: {
    fontSize: 18,
    lineHeight: 1.6,
    marginTop: 0,
  },
  synonyms: {
    marginTop: 10,
  },
  antonyms: {
    marginTop: 6,
  },
  sectionHeading: {
    marginTop: 28,
    marginBottom: 8,
  },
  paragraph: {
    lineHeight: 1.6,
    marginTop: 0,
  },
});
